//TODO: This is a temp sol. to enable parallel testing of new UA changes & weekly sanity, to be removed once UA is fully rolled out
import { asType } from '@sparky/framework'
import manifests from '.'
// import { getVarValue } from '../../common/utils/Sparky'

import type { ActivationManifest } from '../renderer'
// import { FF_ENABLE_DEFAULT_TSG } from '../../common/utils/FeatureFlags'


export default asType<Record<string, ActivationManifest | undefined>>({
  ...manifests,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'aiops': require('./UAiops').default } : undefined,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'aiops-free': require('./UAiopsFree').default } : undefined,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'iot': require('./UAIot').default } : undefined,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'saas': require('./UASaaS').default } : undefined,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'ng_casb': require('./UNgCasb').default } : undefined,
  // ...(getVarValue(FF_ENABLE_DEFAULT_TSG)) ? { 'directory_sync': require('./directory_sync').default } : undefined
})
